import { PermissionT } from "../types";

export const VISION_SELF_DESIGN_ROLES = ["vision_designer_user", "vision_admin", "vision_proposal_admin"];
export const canRequestVisionSelfDesign = (permissions: PermissionT[]): boolean => {
  return permissions.some((permission) => VISION_SELF_DESIGN_ROLES.includes(permission.name));
};

export default canRequestVisionSelfDesign;
